<template>
    <vs-card class="upload shadow-none" :class="{
        'upload__drag-over': isDraggingOver,
        'upload__drag-over--error': error,
        'upload__disabled': disabled
    }">
        <input
            type="file"
            ref="fileInput"
            @change="handleFileUpload"
            :multiple="isMultipleFiles"
            :accept="format"
            style="display: none"
        />

        <div
            @click="triggerFileInput"
            @drop.prevent="handleDrop"
            @dragover.prevent="handleDragOver"
            @dragleave="handleDragLeave"
        >
            <div class="upload__bg"></div>
            <div class="upload__wrapper">
                <div class="upload__description">{{$t('upload.title')}}</div>

                <div class="upload__icon">
                    <vs-icon icon-pack="feather" icon="icon-upload" size="large"/>
                </div>

                <div>{{error}}</div>
            </div>
        </div>
    </vs-card>
</template>

<script>
export default {
    name: 'v-upload',

    props: {
        format: {
            type: String,
            default: () => 'text/csv'
        },
        isMultipleFiles: {
            type: Boolean,
            default: false,
        },
        maxFileSizeMB: {
            type: Number,
            default: 10,
        },
        error: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isDraggingOver: false,
            selectedFiles: [],
        }
    },

    computed: {
        maxFileSize() {
            return this.maxFileSizeMB * 1024 * 1024
        }
    },

    watch: {
        '$i18n.locale'() {
            if (this.error) {
                this.$emit('error', this.$t('upload.size', {size: this.maxFileSizeMB}))
            }
        }
    },

    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click()
        },

        handleFileUpload(event) {
            const files = event.target.files
            this.setSelectedFiles(files)
            this.uploadFiles(files)
        },

        handleDrop(event) {
            this.isDraggingOver = false
            const files = event.dataTransfer.files
            this.setSelectedFiles(files)
            this.uploadFiles(files)
        },

        handleDragOver() {
            this.isDraggingOver = true
        },

        handleDragLeave() {
            this.isDraggingOver = false
        },

        setSelectedFiles(files) {
            if (this.isMultipleFiles) {
                this.selectedFiles = Array.from(files)
            } else {
                this.selectedFiles = files.length > 0 ? [files[0]] : []
            }
        },

        async uploadFiles(files) {
            if (!this.selectedFiles.length) {
                return
            }

            if (this.selectedFiles.some(file => file.size > this.maxFileSize)) {
                this.$emit('error', this.$t('upload.size', {size: this.maxFileSizeMB}))
                return
            }

            this.$emit('result', files)
        },
    }
}
</script>

<style lang="scss" scoped>
@mixin active {
    //border: 1px dotted rgba(var(--vs-primary), 1);
    transition: all .20s ease;

    .upload__bg {
        opacity: 1;
        transition: all .20s ease;
    }
}

.upload {
    border: 1px dashed rgba(var(--vs-primary), 1);
    border-radius: 10px;
    text-align: center;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    transition: all .20s ease;
    cursor: pointer;

    &:hover {
        @include active;
    }

    &__drag-over {
        @include active;

        &--error {
            border-color: rgba(var(--vs-danger), 1);
            color: rgba(var(--vs-danger), 1);
        }
    }

    &__bg {
        width: 100%;
        height: 100%;
        background-color: rgba(var(--vs-bodyBg), .5);
        transition: all .20s ease;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }

    &__description {
        font-size: 20px;
        padding: 15px 0;
    }

    &__icon {
        padding-bottom: 15px;
    }

    &__wrapper {
        position: relative;
        z-index: 9;
    }

    &__alert {
        margin-bottom: 15px;
    }

    &__disabled {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }
}
</style>
